<template>
  <div class="dataForm" v-if="detail" style="margin-left:0">
    <div class="form-title mb-10 mt-10">
      <span class="label green" >物</span>
      <span class="left">物料基本信息</span>
    </div>
    <el-descriptions >
      <el-descriptions-item label="物料编号：">{{detail.no}}</el-descriptions-item>
      <el-descriptions-item label="物料名称：">{{detail.name}}</el-descriptions-item>
      <el-descriptions-item label="物料类别：">{{detail.materialClass}}</el-descriptions-item>
      <el-descriptions-item label="物料单位：">{{detail.materialUnit}}</el-descriptions-item>
      <el-descriptions-item label="封装规格：">{{detail.materialStandard}}</el-descriptions-item>
      <el-descriptions-item label="型号：">{{detail.model}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  emits: ['update:visibel', 'submit'],

  setup(props) {
    const { t } = useI18n()

    const dataMap = reactive({
      detail: props.detail
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
